import { useTranslation } from 'react-i18next';
import { galleryImages } from '@/mocks/menu';

export default function Gallery() {
  const { t } = useTranslation();
  return (
    <section id="gallery" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center justify-center gap-2 text-xs font-semibold tracking-[0.3em] uppercase text-primary-600">
            <span className="h-px w-8 bg-primary-500"></span>
            {t('gallery.eyebrow')}
            <span className="h-px w-8 bg-primary-500"></span>
          </span>
          <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight text-foreground-950 md:text-4xl">
            {t('gallery.title')}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            {t('gallery.subtitle')}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {galleryImages.map((img, i) => (
            <div
              key={img.id}
              className={`group relative overflow-hidden rounded-lg ${
                i === 0 ? 'lg:row-span-2' : ''
              }`}
            >
              <img
                src={img.image}
                alt={t(`gallery.t.${img.id}`)}
                className="h-full min-h-[260px] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 flex items-end bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <p className="p-4 text-sm font-medium text-background-50">{t(`gallery.t.${img.id}`)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}